import { useEffect, useState } from "react";
import Layout from "../Layout";
import dynamic from "next/dynamic";
import Hero from "../Hero";
import SearchFilter from "../SearchFilter";
import Pagination from "../Pagination";
import AvailableTutors from "../AvailableTutors";
import Breadcrumbs from "../Breadcrumbs";
import TutorCard from "../TutorCard";
import RelatedLinks from "../RelatedLinks";
import SubjectLinks from "../SubjectLinks";
import TutorFooter from "../TutorFooter";
import SchemaOrg from "../SchemaOrg";
import { ContactUsBox } from "../ContactUsBox";
import { mediaQueries } from "../../util/sharedStyles/mediaQueries";
import FAQs from "../FAQs";
import Footer from "@mytutor/shared-react-web-components/lib/Footer";
import HowItWorksModal from "../HowItWorksModal";
import SeeMoreTutors from "../SeeMoreTutors";
import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';

const AuthenticatedFooter = dynamic(() => import("../AuthenticatedFooter"), {
  loading: () => <Footer />,
});

const getItems = (tutorsList) => {
  return tutorsList
    ? tutorsList.map((tutor, i) => ({
        item_name: (tutor.firstName + "_" + tutor.lastName).toLowerCase(),
        item_id: tutor.id,
        price: null,
        item_brand: "mytutor",
        item_category: null,
        item_category2: null,
        item_variant: null,
        item_list_name: "/view-tutors",
        index: i,
        quantity: 1,
        user_type: null,
      }))
    : [];
};

const TutorListing = ({
  tutorsList,
  paginationData,
  tutorAggregate,
  subjectAndLevel,
  urlParameters,
  metadata,
  cookies,
  isAuthenticated,
}) => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_item_list",
      ecommerce: {
        ecom_currency: "GBP",
        items: getItems(tutorsList),
      },
    });

    const tutorListArray = tutorsList ? tutorsList : [];
    trackSelfDescribingEvent({
      event: {
        schema: 'iglu:uk.co.mytutor/tutor_list_viewed/jsonschema/1-0-0',
        data: {"tutor_list": tutorListArray },
      }
    })
  }, [tutorsList]);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  return (
    <div css={mediaQueries}>
      <SchemaOrg
        tutorAggregate={tutorAggregate}
        metadata={metadata}
        paginationData={paginationData}
      />
      <Layout metadata={metadata} cookies={cookies}>
        <Hero
          title={metadata.headerTitle}
          description={metadata.headerDescription}
        />

        <SearchFilter
          subjectAndLevel={subjectAndLevel}
          urlParameters={urlParameters}
        />
        <AvailableTutors
          paginationData={paginationData}
          subjectAndLevel={subjectAndLevel}
          urlParameters={urlParameters}
        />
        <TutorCard
          tutorsList={tutorsList}
          sidebarCTA={<ContactUsBox isAuthenticated={isAuthenticated} />}
        />

        {paginationData?.numberOfPages > 1 && !isAuthenticated ? (
          <SeeMoreTutors />
        ) : null}

        {paginationData?.numberOfPages > 1 && isAuthenticated ? (
          <Pagination paginationData={paginationData} />
        ) : null}

        {tutorsList?.length ? (
          <aside
            className="notForDesktopFlex"
            css={{ justifyContent: "center" }}
          >
            <ContactUsBox isAuthenticated={isAuthenticated} />
          </aside>
        ) : null}

        {isAuthenticated && hasMounted ? (
          <>
            <Breadcrumbs
              urlSubject={subjectAndLevel.subject}
              urlLevel={subjectAndLevel.level}
              authenticated={true}
            />
            <AuthenticatedFooter />
            <HowItWorksModal />
          </>
        ) : (
          <>
            <RelatedLinks metadata={metadata} />
            <Breadcrumbs
              urlSubject={subjectAndLevel.subject}
              urlLevel={subjectAndLevel.level}
              authenticated={false}
            />
            <SubjectLinks subjectAndLevel={subjectAndLevel} />
            <FAQs />
            <TutorFooter metadata={metadata} />
            <Footer />
          </>
        )}
      </Layout>
    </div>
  );
};

export default TutorListing;
